import type { Filters } from '../view/state/selected-filters';

export function getUnitFromFilter(filters: Filters): {
  accureId: string | undefined;
} {
  let accureId: string | undefined;
  if (filters.coreFilters.domain === 'battery' && filters.batteryFilters) {
    const entry = ORDERED_ACCURE_LEVELS_BY_PRIORITY.map((level) => ({
      key: level,
      levelKey: level + 'Id',
    })).find((entry) => (filters.batteryFilters as any)[entry.levelKey]);

    if (entry) {
      const selection =
        filters.batteryFilters?.[
          entry.levelKey as keyof typeof filters.batteryFilters
        ];

      return {
        accureId: Array.isArray(selection) ? selection[0] : selection,
      };
    }
  }

  if (filters.coreFilters.domain === 'pcs' && filters.pcsFilters) {
    const pcsId = (filters.pcsFilters as any).pcsId;

    if (pcsId) {
      return {
        accureId: Array.isArray(pcsId) ? pcsId[0] : pcsId,
      };
    }
  }

  return {
    accureId,
  };
}

// TODO: move to entities
const ORDERED_ACCURE_LEVELS_BY_PRIORITY = [
  'pack',
  'cell',
  'array',
  'bank',
  'container',
  'module',
  'node',
  'pcs',
  'system',
] as const;
